function getAllMakesModelsYears(data) {
  const makes = Object.keys(data);
  const models = new Set();
  const years = new Set();

  for (const make of makes) {
    for (const model of Object.keys(data[make])) {
      models.add(model);
      for (const year of Object.keys(data[make][model])) {
        years.add(year);
      }
    }
  }

  return {
    makes,
    models: Array.from(models),
    years: Array.from(years)
  };
}


$(document).ready(function () {
  // Defensive: try to parse MMY_DATA, fallback to empty object if error
  var MMY_DATA = window.MMY_DATA || {};
  try {
    if (typeof MMY_DATA === "string") {
      MMY_DATA = JSON.parse(MMY_DATA);
    }
    if (typeof MMY_DATA !== "object" || MMY_DATA === null) MMY_DATA = {};
  } catch (e) {
    MMY_DATA = {};
  }

  const yearSelector = $("select#GetYear");
  const makeSelector = $("select#GetMake");
  const modelSelector = $("select#GetModel");
  const redirectBtn = $("[data-redirect]");

  let makeToModels = {};
  let modelToMake = {};

  // Utility
  function resetSelect($select, placeholder) {
    $select.empty();
    $select.append(`<option value="" disabled selected>${placeholder}</option>`);
    $select.prop("disabled", true);
  }
  function enableSelect($select) {
    $select.prop("disabled", false);
    $select.removeClass("pointer-non");
  }

  function buildMappings() {
    makeToModels = {};
    modelToMake = {};
    const { makes } = getAllMakesModelsYears(MMY_DATA);
    makes.forEach(function (make) {
      const modelsObj = MMY_DATA[make] || {};
      const models = Object.keys(modelsObj);
      makeToModels[make] = models;
      models.forEach(function (model) {
        if (!modelToMake[model]) {
          modelToMake[model] = make;
        }
      });
    });
  }

  // Load makes and all models on page load
  function loadMakesAndModels() {
    resetSelect(makeSelector, "Select Make");
    resetSelect(modelSelector, "Select Model");
    resetSelect(yearSelector, "Select Year");
    redirectBtn.addClass("disabled").attr("href", "");

    const { makes, models } = getAllMakesModelsYears(MMY_DATA);

    if (makes && makes.length > 0) {
      makes.forEach(function (make) {
        makeSelector.append(`<option value="${make}">${make}</option>`);
      });
      enableSelect(makeSelector);
    } else {
      console.log("No makes extracted from MMY_DATA");
    }

    if (models && models.length > 0) {
      models.forEach(function (model) {
        modelSelector.append(`<option value="${model}">${model}</option>`);
      });
      enableSelect(modelSelector);
    }
  }

  // Wait a bit to ensure DOM is ready, then load
  setTimeout(function () {
    buildMappings();
    loadMakesAndModels();
  }, 500);

  // When make changes, show models for that make
  makeSelector.on("change", function () {
    resetSelect(modelSelector, "Select Model");
    resetSelect(yearSelector, "Select Year");
    redirectBtn.addClass("disabled").attr("href", "");
    const selectedMake = makeSelector.val();
    if (!selectedMake) return;

    const models = makeToModels[selectedMake] || [];

    if (models && models.length > 0) {
      models.forEach(function (model) {
        modelSelector.append(`<option value="${model}">${model}</option>`);
      });
      enableSelect(modelSelector);
    }
  });

  // When model changes, show years for that make/model
  modelSelector.on("change", function () {
    resetSelect(yearSelector, "Select Year");
    redirectBtn.addClass("disabled").attr("href", "");
    let selectedMake = makeSelector.val();
    const selectedModel = modelSelector.val();

    if (selectedModel && (!selectedMake || !(makeToModels[selectedMake] || []).includes(selectedModel))) {
      const autoMake = modelToMake[selectedModel];
      if (autoMake) {
        makeSelector.val(autoMake);
        selectedMake = autoMake;
      }
    }

    if (!selectedMake || !selectedModel) return;

    // Extract years for this make/model using getAllMakesModelsYears logic
    const makeModelData = { [selectedMake]: { [selectedModel]: MMY_DATA[selectedMake][selectedModel] } };
    const { years } = getAllMakesModelsYears(makeModelData);
    const sortedYears = years.sort((a, b) => b.localeCompare(a));

    if (sortedYears && sortedYears.length > 0) {
      sortedYears.forEach(function (year) {
        yearSelector.append(`<option value="${year}">${year}</option>`);
      });
      enableSelect(yearSelector);
    }
  });

  // When year changes, set redirect href if available
  yearSelector.on("change", function () {
    redirectBtn.addClass("disabled").attr("href", "");
    const selectedMake = makeSelector.val();
    const selectedModel = modelSelector.val();
    const selectedYear = yearSelector.val();
    if (!selectedMake || !selectedModel || !selectedYear) return;
    // Get collection_url from MMY_DATA
    const yearArr = MMY_DATA[selectedMake][selectedModel][selectedYear];
    let url = "";
    if (Array.isArray(yearArr) && yearArr.length && yearArr[0].collection_url) {
      url = yearArr[0].collection_url;
    }
    if (url) {
      redirectBtn.removeClass("disabled").attr("href", url);
    }
  });
});
